'use client';

import React from 'react';
import { LocaleContext } from '@/contexts/LocaleContext';
import { useLocaleFromPath } from '@/hooks/useLocaleFromPath';
import { getTranslations, t as translate, type Translations } from '@/lib/translations';

export function useTranslations() {
  const contextLocale = React.useContext(LocaleContext);
  const pathLocale = useLocaleFromPath();
  const locale = contextLocale?.locale ?? pathLocale;
  const tr = getTranslations(locale);
  const t = (key: string, vars?: Record<string, string | number>) => translate(tr, key, vars);
  return { t, translations: tr };
}
